import React, { useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

function Checkbox({
  name,
  label,
  disabled = false,
  checked = false,
  onChange,
  indeterminate = false,
  className = "", // Single prop for custom classes
  ...restProps
}) {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  // Merge all Tailwind classes into a single string
  const classes = twMerge(
    // Input classes
    "w-4 h-4 border-gray-300 text-sflPrimary focus:ring-sflPrimary",
    disabled
      ? "text-slate-500 border-slate-200 shadow-none cursor-not-allowed"
      : "cursor-pointer",
    // Label classes
    "ml-2 text-sm font-medium text-gray-700",
    disabled ? "text-slate-400 cursor-not-allowed" : "",
    // Custom classes passed via className prop
    className
  );

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        name={name}
        id={name}
        value={name}
        className={classes}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        ref={checkboxRef}
        {...restProps}
      />
      <label
        htmlFor={name}
        className={`block ml-2 text-sm font-medium text-gray-700 ${
          disabled ? "text-slate-400 cursor-not-allowed" : ""
        }`}
      >
        {label}
      </label>
    </div>
  );
}

export default Checkbox;
